import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';
import PaymentCheckbox from './PaymentCheckbox';

import { Link, Redirect} from 'react-router-dom';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class PaymentHoursOpened extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      errors_listing: false,
      loaded: 0,
      payment_order_id: '',
      date_start: '',
      date_finish: '',
      payed: 0,
      payment_orders_list: [],
      checkbox_marked_ids: [],
      checkbox_marked_data: [],
      data_payment_hours: [],
      checkbox_changed: 0,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.search = this.search.bind(this);
    this.refreshTable = this.refreshTable.bind(this);
    this.add = this.add.bind(this);

    this.PaymentCheckbox = this.PaymentCheckbox.bind(this);
    this.unmarkAllCheckbox = this.unmarkAllCheckbox.bind(this);
    this.markAllCheckbox = this.markAllCheckbox.bind(this);
    this.markedCheckboxId = this.markedCheckboxId.bind(this);
    this.UnmarkCheckboxId = this.UnmarkCheckboxId.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/ordens/pagamento/lista/missao';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({payment_orders_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  search(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      payed: this.state.payed,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/calcular/pagamentos/periodo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if(responseJson.status === 'warning') {
          self.setState({
            errors_listing: true,
            errors_messages: responseJson.data.messages,
            data_payment_hours: responseJson.data.main,
          });
        } else {
          self.setState({
            errors_listing: false,
            errors_messages: [],
            data_payment_hours: responseJson.data.main,
          });
        }
        self.handleAlert('', responseJson.status, 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  refreshTable(event) {
    this.handleAlert('', '', 'open');
    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      payed: this.state.payed,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/calcular/pagamentos/periodo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if(responseJson.status === 'warning') {
          self.setState({
            errors_listing: true,
            errors_messages: responseJson.data.messages,
            data_payment_hours: responseJson.data.main,
          });
        } else {
          self.setState({
            errors_listing: false,
            errors_messages: [],
            data_payment_hours: responseJson.data.main,
          });
        }
        self.handleAlert(event.message, event.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      checkbox_marked_ids: this.state.checkbox_marked_ids,
      checkbox_marked_data: this.state.checkbox_marked_data,
      payment_order_id: this.state.payment_order_id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/ordem/pagamento/incluir/pagamentos/horas', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.refreshTable(responseJson);
          self.setState({checkbox_marked_ids: [], checkbox_marked_data: []});
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  PaymentCheckbox (cell, row) {
    var botao = (
      <div>
        <PaymentCheckbox handleAlert={this.handleAlert} markedCheckboxId={this.markedCheckboxId} UnmarkCheckboxId={this.UnmarkCheckboxId} checkbox_marked_ids={this.state.checkbox_marked_ids} id={cell} payment_data={row} />
      </div>
    );

    return botao;
  }

  unmarkAllCheckbox () {
    this.setState({checkbox_marked_ids: [], checkbox_marked_data: []});
  }

  markAllCheckbox () {
    var self = this;
    var ids_temp = [];
    var data_temp = [];
    Object.keys(self.state.checkbox_marked_data).map(function(k) {
      ids_temp.push(self.state.checkbox_marked_data[k].id);
      data_temp.push(self.state.checkbox_marked_data[k]);
    });
    self.setState({checkbox_marked_ids: ids_temp, checkbox_marked_data: data_temp});
  }

  markedCheckboxId (value) {
    var ids_temp = this.state.checkbox_marked_ids;
    var data_temp = this.state.checkbox_marked_data;
    ids_temp.push(value.id);
    data_temp.push(value);
    this.setState({checkbox_marked_ids: ids_temp, checkbox_marked_data: data_temp});
  }

  UnmarkCheckboxId (value) {
    var self = this;
    var ids_temp = [];
    var data_temp = [];
    var checkbox_ids = this.state.checkbox_marked_ids;
    checkbox_ids.map(function(checked_id) {
      if(checked_id !== value.id) {
        ids_temp.push(checked_id);
        data_temp.push(value);
      }
    });
    self.setState({checkbox_marked_ids: ids_temp, checkbox_marked_data: data_temp});
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Pagamentos.ListaDePagamentosEmAbertoHoras.titulo}</h3>
      <Link to="/treinamentos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      {this.state.errors_listing &&
        <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
          <button onClick={() => self.setState({ errors_listing: false, errors_messages: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>{this.locale.Pagamentos.ListaDePagamentosEmAbertoHoras.atencaoRelatoriosAindaNaoConcluidos}:</strong>
          {Object.keys(self.state.errors_messages).map(function(k) {
            var message = self.state.errors_messages[k];
            return (
              <p>- {message}</p>
            );
          })}
        </div>
      }
      <hr/>
      <form onSubmit={this.search}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Pagamentos.ListaDePagamentosEmAbertoHoras.formulario.DataInicial}:</label>
              <InputMask value={this.state.date_start} maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Pagamentos.ListaDePagamentosEmAbertoHoras.formulario.DataFinal}:</label>
              <InputMask value={this.state.date_finish} maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Pagamentos.ListaDePagamentosEmAbertoHoras.formulario.IncluirPagos}?</label>
              <Select
                className=""
                name="payed"
                value={this.state.payed}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'payed')}
                options={[
                  {value: 0, label: this.locale.general.nao},
                  {value: 1, label: this.locale.general.sim},
                ]}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Pagamentos.ListaDePagamentosEmAbertoHoras.formulario.botaoBuscarPagamentos}</button>
          </div>
        </div>
      </form>
      <hr/>
      <form onSubmit={this.add}>
          <div className="form-group">
            <label>{this.locale.Pagamentos.ListaDePagamentosEmAbertoHoras.formularioOrdemDePagamento.OrdemDePagamento}:</label>
            <Select
              className="form-field-name"
              name="payment_order_id"
              value={this.state.payment_order_id}
              searchable={true}
              placeholder={this.locale.Pagamentos.ListaDePagamentosEmAbertoHoras.formularioOrdemDePagamento.placeholder.SelecionarOrdemDePagamento}
              onChange={this.handleSelectChange.bind(this, 'payment_order_id')}
              options={this.state.payment_orders_list}
            />
          </div>
          <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-plus"></i> {this.locale.Pagamentos.ListaDePagamentosEmAbertoHoras.formularioOrdemDePagamento.botaoAdicionarOrdemDePagamento}</button>
          <button type="button" onClick={this.delete} className="btn btn-danger btn-block"><i className="fa fa-fw fa-trash"></i> {this.locale.Pagamentos.ListaDePagamentosEmAbertoHoras.formularioOrdemDePagamento.botaoDeletarPagamentos}</button>
      </form>
      <hr/>
      <BootstrapTable data={this.state.data_payment_hours} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Pagamentos.ListaDePagamentosEmAbertoHoras.tabela.semPagamentosEmAberto}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.PaymentCheckbox} width='30'>
        </TableHeaderColumn>
        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Pagamentos.ListaDePagamentosEmAbertoHoras.tabela.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="inscription" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='70'>{this.locale.Pagamentos.ListaDePagamentosEmAbertoHoras.tabela.Matricula}</TableHeaderColumn>
        <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Pagamentos.ListaDePagamentosEmAbertoHoras.tabela.NomeDoColaborador}</TableHeaderColumn>
        <TableHeaderColumn dataField="total_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Pagamentos.ListaDePagamentosEmAbertoHoras.tabela.TotalGeral}</TableHeaderColumn>
        <TableHeaderColumn dataField="total_diurn_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Pagamentos.ListaDePagamentosEmAbertoHoras.tabela.HorasDiurnas}</TableHeaderColumn>
        <TableHeaderColumn dataField="total_nocturn_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Pagamentos.ListaDePagamentosEmAbertoHoras.tabela.HorasNoturnas}</TableHeaderColumn>
        <TableHeaderColumn dataField="holiday_total_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Pagamentos.ListaDePagamentosEmAbertoHoras.tabela.HorasDomingosFeriados}</TableHeaderColumn>
        <TableHeaderColumn dataField="soma_total_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Pagamentos.ListaDePagamentosEmAbertoHoras.tabela.SomaGeral}</TableHeaderColumn>
      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default PaymentHoursOpened;



// WEBPACK FOOTER //
// ./src/Components/Payments/PaymentHoursOpened.js